<div class="something-went-wrong-container">
  <div>
    <!--<db-loading-screen [pageBlocker]="true"></db-loading-screen>-->
    <div class="something-went-wrong-title"><span [innerHTML]="'text_somethingWentWrong' | dbText"></span></div>
    <div class="something-went-wrong-desc" [innerHTML]="'text_somethingWentWrongDesc' | dbText"></div>
    <!--<div class="something-went-wrong__button-wrap mt20">
      <a class="ds-btn-blue" (click)="logout()"  [ngClass]="{'ds-btn-disabled': loading}">
        <span *ngIf="!loading">{{'text_somethingWentWrongLogOut' | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>-->
  </div>
</div>
